
if (!customElements.get('horizontal-slider')) {
    customElements.define(
      'horizontal-slider',
      class HorizontalSlider extends HTMLElement {
        constructor() {
          super();
  
          this.slides = null;
          this.initialScrollY = null;
          this.lastScrollTop = null;
          this.maxScrollLeft = null;
          this.tablet = null;
          this.scrollDivider = null;
        }
  
        connectedCallback() {
            this.slides = this.querySelectorAll('.product-vs__row');
            this.maxScrollLeft = this.scrollWidth - this.clientWidth;
            this.tablet = window.matchMedia("(max-width: 749px)").matches;
            this.scrollDivider = this.tablet ? 30 : 15;
            this.lastScrollTop = window.scrollY;
          
            // Touch handling state
            this.touchStartX = 0;
            this.touchStartY = 0;
          
            // Add wheel and touch listeners
            window.addEventListener('wheel', this.handleWheel.bind(this), { passive: false });
            this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
            this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
          
            // Track active rows
            this.addEventListener('scroll', () => {
              this.slides.forEach(slide => {
                this.isElementHorizontallyCentered(slide) 
                  ? slide.classList.add('active') 
                  : slide.classList.remove('active');
              });
            });
          }
          
          handleWheel(e) {
            if (!this.sliderIsInViewport()) return;
          
            const atStart = this.scrollLeft <= 0;
            const atEnd = this.scrollLeft >= this.maxScrollLeft;
          
            // Convert vertical scroll to horizontal
            if (!(atStart && e.deltaY < 0) && !(atEnd && e.deltaY > 0)) {
              e.preventDefault();
              this.scrollLeft += e.deltaY;
            }
          }
          
          handleTouchStart(e) {
            this.touchStartX = e.touches[0].clientX;
            this.touchStartY = e.touches[0].clientY;
          }
          
          handleTouchMove(e) {
            if (!this.sliderIsInViewport()) return;
          
            const touchX = e.touches[0].clientX;
            const touchY = e.touches[0].clientY;
            const deltaX = this.touchStartX - touchX;
            const deltaY = this.touchStartY - touchY;
          
            // Only convert if horizontal movement is stronger than vertical
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
              const atStart = this.scrollLeft <= 0;
              const atEnd = this.scrollLeft >= this.maxScrollLeft;
          
              if (!(atStart && deltaX < 0) && !(atEnd && deltaX > 0)) {
                e.preventDefault();
                this.scrollLeft += deltaX;
                this.touchStartX = touchX; // Update to support continuous drag
              }
            }
          }
  
        sliderIsInViewport() {
          const rect = this.getBoundingClientRect();
          return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
  
        scrollHorizontalSlider(e) {
          const isVisible = this.sliderIsInViewport();
          const currentScrollY = window.scrollY;
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
          if (isVisible)  {
            if (!this.initialScrollY) this.initialScrollY = currentScrollY;
            
            if (scrollTop > this.lastScrollTop){
              this.scrollLeft += (currentScrollY - this.initialScrollY ) / this.scrollDivider;
            }else {
              this.scrollLeft -= (currentScrollY - this.initialScrollY ) / this.scrollDivider;
            }
  
            this.lastScrollTop = currentScrollY;
  
          }
        }
        
        isElementHorizontallyCentered(element) {
          const viewportWidth = window.innerWidth;
          const rect = element.getBoundingClientRect();
          const elementCenter = rect.left + rect.width / 2;
          const viewportCenter = viewportWidth / 2;
          const threshold = element.offsetWidth; 
      
          return Math.abs(elementCenter - viewportCenter) <= threshold;
        }
      }
    );
  }
  